import { DeleteHttpCookie, GetPosToken } from "@/server-types";
import { del, get } from "../request-helpers";
import { useCustomQuery } from "../custom-query";
import { queryClient } from "..";
import { useCustomMutation } from "../custom-mutation";
import { usePosTokenStore } from "@/stores/usePosTokenStore";
import { useShallow } from "zustand/react/shallow";

export const useDeleteHttpCookie = () => {
  const setIsDeletingPosToken = usePosTokenStore(
    useShallow((state) => state.setIsDeletingPosToken),
  );

  return useCustomMutation({
    mutationFn: ({ cookieName }: { cookieName: string }) =>
      del<DeleteHttpCookie>(`/cookie/${cookieName}`),
    onMutate: () => {
      setIsDeletingPosToken(true);
      queryClient.setQueryData(["getPosToken"], null);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getPosToken"] });
      setIsDeletingPosToken(false);
    },
  });
};

export const useGetPosToken = () => {
  const isDeletingPosToken = usePosTokenStore(
    useShallow((state) => state.isDeletingPosToken),
  );

  return useCustomQuery({
    queryKey: ["getPosToken"],
    queryFn: () => get<GetPosToken>(`/cookie/pos`),
    placeholderData: null,
    enabled: !isDeletingPosToken,
    // gcTime: 0,
    // refetchInterval: 5000,
    // refetchOnMount: true,
    // refetchOnReconnect: true,
    // refetchOnWindowFocus: true,
  });
};
